var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "ContentLoader",
        {
          ref: "contentLoader",
          attrs: {
            "profile-owner": _vm.profileOwner,
            "load-fn": _vm.loadFn,
            "process-content-fn": false,
            "content-name": "items"
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _vm.permissions.isOwner
                    ? _c(
                        "div",
                        { staticClass: "row mb-6" },
                        [
                          _c(
                            "VsButton",
                            {
                              attrs: {
                                type: "primary",
                                icon: "fa:plus",
                                tracker: {
                                  category: "playlist",
                                  action: "open-create"
                                }
                              },
                              on: { click: _vm.addNewPlaylist }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("playlist.actions.create", {
                                      item: _vm.$t("playlist.label", {
                                        count: 0
                                      })
                                    })
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.getFilteredPropContent(props), function(
                      playlist
                    ) {
                      return _c(
                        "div",
                        {
                          key: playlist.slug,
                          staticClass: "col-12 col-md-6 col-xl-4"
                        },
                        [
                          _c("PlaylistsViewItem", {
                            staticClass: "mb-5",
                            attrs: {
                              playlist: playlist,
                              "base-url": _vm.baseUrl,
                              "use-router": true
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "ProfileVideosEmptyState",
            {
              attrs: { slot: "empty", options: _vm.emptyStateOptions },
              slot: "empty"
            },
            [
              _vm.permissions.isOwner
                ? _c(
                    "VsButton",
                    {
                      attrs: {
                        type: "primary",
                        tracker: {
                          category: "playlist",
                          action: "open-create"
                        }
                      },
                      on: { click: _vm.addNewPlaylist }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.click_here")) +
                          "\n        " +
                          _vm._s(_vm.$t("common.to")) +
                          "\n        " +
                          _vm._s(
                            _vm.$t("playlist.actions.create", {
                              item: _vm.$t("playlist.label", { count: 0 })
                            })
                          ) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }